import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

type RemoveLocationFromRetailerNetworkDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  isRemoveLocationFromRetailerNetworkInProgress?: boolean;
};

export const RemoveLocationFromRetailerNetworkDialog = ({
  open,
  setOpen,
  onConfirm,
  isRemoveLocationFromRetailerNetworkInProgress,
}: RemoveLocationFromRetailerNetworkDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove Location from Retailer Network'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: isRemoveLocationFromRetailerNetworkInProgress,
    }}
  >
    {isRemoveLocationFromRetailerNetworkInProgress && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove this Location from the Retailer Network? This will not
      delete the location, only remove it from the Retailer Network.
    </Typography>
  </ConfirmDialog>
);
